<template>
  <div class="sidebar close col-xl-2" style="height: 100vh; position: fixed">
    <div class="arrow-left">
      <svg
          id="btn"
          width="9"
          height="18"
          viewbox="0 0 9 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
        <path
            d="M0.33285 9.00016C0.332317 8.72757 0.427255 8.46339 0.601183 8.25349L6.43452 1.25349C6.63254 1.01524 6.91711 0.865411 7.2256 0.836968C7.5341 0.808525 7.84126 0.903797 8.07952 1.10183C8.31777 1.29985 8.4676 1.58442 8.49604 1.89291C8.52448 2.20141 8.42921 2.50857 8.23118 2.74683L3.00452 9.00016L8.04452 15.2535C8.14143 15.3728 8.2138 15.5101 8.25747 15.6575C8.30114 15.8049 8.31525 15.9595 8.29898 16.1124C8.28272 16.2652 8.23641 16.4134 8.16271 16.5483C8.089 16.6832 7.98936 16.8022 7.86952 16.8985C7.74956 17.0053 7.60883 17.0863 7.45614 17.1362C7.30345 17.1861 7.1421 17.204 6.9822 17.1886C6.82229 17.1733 6.66727 17.1251 6.52686 17.0471C6.38644 16.969 6.26365 16.8629 6.16618 16.7352L0.531184 9.73516C0.384748 9.51923 0.314918 9.26044 0.33285 9.00016Z"
            fill="#C0BEFF"
        ></path>
      </svg>
    </div>
    <div class="logo">
      <a href="javascript:void(0);"
      ><img src="./../../../assets/images/logo/logo-white.png" alt=""
      /></a>
    </div>
    <nav>
      <ul class="list-unstyled primary-list">
        <li>
          <router-link :to="{ name: 'dashboard' }" :title="$t('homePage')">
            <div class="icon">
              <svg
                  width="16"
                  height="15"
                  viewbox="0 0 16 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="path-1-inside-1" fill="white">
                  <rect
                      x="8.44336"
                      width="6.56706"
                      height="6.5625"
                      rx="1"
                  ></rect>
                </mask>
                <rect
                    x="8.44336"
                    width="6.56706"
                    height="6.5625"
                    rx="1"
                    stroke="#C0BEFF"
                    stroke-width="3"
                    mask="url(#path-1-inside-1)"
                ></rect>
                <mask id="path-2-inside-2" fill="white">
                  <rect
                      x="8.44336"
                      y="7.5"
                      width="6.56706"
                      height="6.5625"
                      rx="1"
                  ></rect>
                </mask>
                <rect
                    x="8.44336"
                    y="7.5"
                    width="6.56706"
                    height="6.5625"
                    rx="1"
                    stroke="#C0BEFF"
                    stroke-width="3"
                    mask="url(#path-2-inside-2)"
                ></rect>
                <mask id="path-3-inside-3" fill="white">
                  <rect y="7.5" width="6.56706" height="6.5625" rx="1"></rect>
                </mask>
                <rect
                    y="7.5"
                    width="6.56706"
                    height="6.5625"
                    rx="1"
                    stroke="#C0BEFF"
                    stroke-width="3"
                    mask="url(#path-3-inside-3)"
                ></rect>
                <mask id="path-4-inside-4" fill="white">
                  <rect width="6.56706" height="6.5625" rx="1"></rect>
                </mask>
                <rect
                    width="6.56706"
                    height="6.5625"
                    rx="1"
                    stroke="#C0BEFF"
                    stroke-width="3"
                    mask="url(#path-4-inside-4)"
                ></rect>
              </svg>
            </div>
            <span>{{ $t("homePage") }}</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'contracts' }" :title="$t('contracts')">
            <div class="icon">
              <svg
                  width="17"
                  height="19"
                  viewbox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M4.57692 8.86667H3.92308V10.1333H4.57692V8.86667ZM12.4231 10.1333H13.0769V8.86667H12.4231V10.1333ZM4.57692 5.06667H3.92308V6.33333H4.57692V5.06667ZM7.19231 6.33333H7.84615V5.06667H7.19231V6.33333ZM12.4231 0.633333L12.886 0.184933L12.6938 0H12.4231V0.633333ZM16.3462 4.43333H17V4.17113L16.8091 3.98493L16.3462 4.43333ZM8.5 14.5667L8.79292 15.1329L8.84523 15.1075L8.89231 15.0733L8.5 14.5667ZM4.57692 10.1333H12.4231V8.86667H4.57692V10.1333ZM4.57692 6.33333H7.19231V5.06667H4.57692V6.33333ZM15.0385 17.7333H1.96154V19H15.0385V17.7333ZM1.30769 17.1V1.9H0V17.1H1.30769ZM1.96154 1.26667H12.4231V0H1.96154V1.26667ZM15.6923 4.43333V17.1H17V4.43333H15.6923ZM11.9602 1.08173L15.8832 4.88173L16.8091 3.98493L12.886 0.184933L11.9602 1.08173ZM1.96154 17.7333C1.78813 17.7333 1.62182 17.6666 1.4992 17.5478C1.37658 17.4291 1.30769 17.268 1.30769 17.1H0C0 17.6039 0.206662 18.0872 0.574521 18.4435C0.942381 18.7998 1.44131 19 1.96154 19V17.7333ZM15.0385 19C15.5587 19 16.0576 18.7998 16.4255 18.4435C16.7933 18.0872 17 17.6039 17 17.1H15.6923C15.6923 17.268 15.6234 17.4291 15.5008 17.5478C15.3782 17.6666 15.2119 17.7333 15.0385 17.7333V19ZM1.30769 1.9C1.30769 1.73203 1.37658 1.57094 1.4992 1.45217C1.62182 1.33339 1.78813 1.26667 1.96154 1.26667V0C1.44131 0 0.942381 0.200178 0.574521 0.556497C0.206662 0.912816 0 1.39609 0 1.9H1.30769ZM5.85062 14.7668C5.99577 14.345 6.409 13.9536 6.936 13.8168C7.429 13.6889 8.06323 13.7725 8.69092 14.3817L9.61677 13.4849C8.67523 12.5729 7.565 12.3411 6.59731 12.5932C5.66492 12.8364 4.90123 13.5217 4.60962 14.3665L5.85192 14.7668H5.85062ZM8.69092 14.3817C8.72772 14.4163 8.76222 14.4531 8.79423 14.4919L9.82731 13.7142C9.76207 13.634 9.69176 13.5579 9.61677 13.4862L8.69092 14.3817ZM8.79423 14.4919C8.89623 14.6186 8.87269 14.6591 8.87662 14.6313C8.87923 14.6135 8.88446 14.6427 8.806 14.7111C8.69294 14.8026 8.56473 14.875 8.42677 14.9251C8.26101 14.9897 8.08813 15.0356 7.91154 15.0619C7.80381 15.0818 7.69364 15.0861 7.58462 15.0746C7.56238 15.0695 7.60815 15.0746 7.67615 15.1215C7.75954 15.1838 7.82084 15.2697 7.85153 15.3673C7.88223 15.4649 7.88081 15.5694 7.84746 15.6661C7.84005 15.6871 7.82995 15.7071 7.81738 15.7257C7.81477 15.7282 7.837 15.7003 7.91154 15.6408C8.06062 15.5243 8.33523 15.3545 8.79292 15.1341L8.20708 14.0005C7.71408 14.2386 7.344 14.4565 7.09031 14.6553C6.96165 14.7526 6.84727 14.8664 6.75031 14.9935C6.62698 15.1534 6.56253 15.3488 6.56723 15.5483C6.58031 15.8219 6.73331 16.0233 6.90069 16.1411C7.04846 16.2475 7.21192 16.2931 7.33223 16.3172C7.57677 16.3641 7.85531 16.3514 8.10769 16.3147C8.60461 16.2412 9.248 16.0335 9.68608 15.6484C9.91361 15.447 10.1294 15.1582 10.1752 14.7795C10.2222 14.3919 10.0784 14.0283 9.826 13.7155L8.79292 14.4919H8.79423ZM8.89231 15.0733C9.10152 14.9184 9.32889 14.7878 9.56969 14.6845L9.05054 13.5217C8.73669 13.6534 8.42285 13.832 8.10769 14.06L8.89231 15.0733ZM9.56969 14.6845C10.4197 14.3285 11.1795 14.516 11.9575 14.8745C12.1537 14.9657 12.3446 15.0645 12.5382 15.1658C12.7265 15.2646 12.9252 15.3697 13.1135 15.4635C13.4745 15.6395 13.9217 15.8333 14.3846 15.8333V14.5667C14.2617 14.5667 14.0603 14.5071 13.7046 14.3336C13.5372 14.25 13.362 14.1563 13.1606 14.0511C12.9645 13.9485 12.7474 13.8358 12.5198 13.7319C11.6071 13.3101 10.4132 12.9517 9.05054 13.5217L9.56969 14.6845Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("contracts") }}</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'customers' }" :title="$t('customers')">
            <div class="icon">
              <svg
                  width="19"
                  height="19"
                  viewbox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M17.8125 17.8125H16.625V14.8438C16.6241 14.0567 16.311 13.3021 15.7544 12.7456C15.1979 12.189 14.4433 11.8759 13.6562 11.875V10.6875C14.7582 10.6888 15.8146 11.1271 16.5938 11.9062C17.3729 12.6854 17.8112 13.7418 17.8125 14.8438V17.8125Z"
                    fill="#C0BEFF"
                ></path>
                <path
                    d="M13.0625 17.8125H11.875V14.8438C11.8741 14.0567 11.561 13.3021 11.0044 12.7456C10.4479 12.189 9.69332 11.8759 8.90625 11.875H5.34375C4.55668 11.8759 3.80211 12.189 3.24557 12.7456C2.68902 13.3021 2.37594 14.0567 2.375 14.8438V17.8125H1.1875V14.8438C1.18876 13.7418 1.62705 12.6854 2.40623 11.9062C3.1854 11.1271 4.24183 10.6888 5.34375 10.6875H8.90625C10.0082 10.6888 11.0646 11.1271 11.8438 11.9062C12.6229 12.6854 13.0612 13.7418 13.0625 14.8438V17.8125Z"
                    fill="#C0BEFF"
                ></path>
                <path
                    d="M11.875 1.1875V2.375C12.6624 2.375 13.4175 2.68778 13.9742 3.24453C14.531 3.80128 14.8438 4.55639 14.8438 5.34375C14.8438 6.13111 14.531 6.88622 13.9742 7.44297C13.4175 7.99972 12.6624 8.3125 11.875 8.3125V9.5C12.9773 9.5 14.0345 9.06211 14.8139 8.28266C15.5934 7.50321 16.0312 6.44606 16.0312 5.34375C16.0312 4.24144 15.5934 3.18429 14.8139 2.40484C14.0345 1.62539 12.9773 1.1875 11.875 1.1875Z"
                    fill="#C0BEFF"
                ></path>
                <path
                    d="M7.125 2.375C7.71217 2.375 8.28614 2.54911 8.77435 2.87532C9.26256 3.20153 9.64307 3.66519 9.86777 4.20766C10.0925 4.75013 10.1513 5.34704 10.0367 5.92292C9.92216 6.49881 9.63941 7.02779 9.22423 7.44297C8.80904 7.85816 8.28006 8.14091 7.70418 8.25546C7.1283 8.37001 6.53138 8.31122 5.98891 8.08652C5.44644 7.86182 4.98279 7.48131 4.65658 6.9931C4.33037 6.50489 4.15625 5.93091 4.15625 5.34375C4.15625 4.55639 4.46903 3.80128 5.02578 3.24453C5.58253 2.68778 6.33764 2.375 7.125 2.375ZM7.125 1.1875C6.30297 1.1875 5.49941 1.43126 4.81591 1.88795C4.13242 2.34465 3.5997 2.99377 3.28513 3.75322C2.97055 4.51268 2.88824 5.34836 3.04861 6.15459C3.20898 6.96083 3.60483 7.7014 4.18609 8.28266C4.76735 8.86392 5.50792 9.25977 6.31416 9.42014C7.12039 9.58051 7.95607 9.4982 8.71553 9.18362C9.47499 8.86905 10.1241 8.33633 10.5808 7.65284C11.0375 6.96935 11.2813 6.16578 11.2813 5.34375C11.2813 4.24144 10.8434 3.18429 10.0639 2.40484C9.28447 1.62539 8.22731 1.1875 7.125 1.1875Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("customers") }}</span></router-link
          >
          <ul class="list-unstyled child-list">
            <li>
              <router-link
                  :to="{ name: 'customersegment' }"
                  :title="$t('customerSegment')"
              ><span>{{ $t("customerSegment") }}</span></router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link :to="{ name: 'invoices' }" :title="$t('invoices')">
            <div class="icon">
              <svg
                  width="17"
                  height="19"
                  viewbox="0 0 17 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M0 0V19H17V4.82308L16.745 4.60385L11.645 0.219231L11.39 0H0ZM1.7 1.46154H10.2V5.84615H15.3V17.5385H1.7V1.46154ZM11.9 2.48462L14.11 4.38462H11.9V2.48462ZM3.4 7.30769V8.76923H13.6V7.30769H3.4ZM3.4 10.9615V12.4231H9.35V10.9615H3.4ZM11.05 10.9615V12.4231H13.6V10.9615H11.05ZM3.4 13.8846V15.3462H9.35V13.8846H3.4ZM11.05 13.8846V15.3462H13.6V13.8846H11.05Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("invoices") }}</span></router-link
          >
          <ul class="list-unstyled child-list">
            <li>
              <router-link :to="{ name: 'invoicesFortnox' }"
              ><span>{{ $t("noxFinanceInvoice") }}</span></router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link :to="{ name: 'products' }" :title="$t('products')">
            <div class="icon">
              <svg
                  width="20"
                  height="19"
                  viewbox="0 0 20 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M20 0H0V6H1V17C1 17.5304 1.21071 18.0391 1.58579 18.4142C1.96086 18.7893 2.46957 19 3 19H17C17.5304 19 18.0391 18.7893 18.4142 18.4142C18.7893 18.0391 19 17.5304 19 17V6H20V0ZM2 2H18V4H2V2ZM17 17H3V6H17V17ZM7 8H13C13 8.53043 12.7893 9.03914 12.4142 9.41421C12.0391 9.78929 11.5304 10 11 10H9C8.46957 10 7.96086 9.78929 7.58579 9.41421C7.21071 9.03914 7 8.53043 7 8Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("products") }}</span></router-link
          >
          <ul class="list-unstyled child-list">
            <li>
              <router-link :to="{ name: 'productSegment' }"
              ><span>{{ $t("productSegment") }}</span></router-link
              >
            </li>
          </ul>
        </li>
        <li>
          <router-link
              :to="{ name: 'statistics' }"
              :title="$t('statisticsData')"
          >
            <div class="icon">
              <svg
                  width="19"
                  height="19"
                  viewbox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 0H1.1875V17.8125H19V19H0V0ZM11.875 4.15625C11.875 3.99878 11.9376 3.84776 12.0489 3.73641C12.1603 3.62506 12.3113 3.5625 12.4688 3.5625H17.2188C17.3762 3.5625 17.5272 3.62506 17.6386 3.73641C17.7499 3.84776 17.8125 3.99878 17.8125 4.15625V8.90625C17.8125 9.06372 17.7499 9.21474 17.6386 9.32609C17.5272 9.43744 17.3762 9.5 17.2188 9.5C17.0613 9.5 16.9103 9.43744 16.7989 9.32609C16.6876 9.21474 16.625 9.06372 16.625 8.90625V5.81875L12.3346 11.0639C12.282 11.128 12.2167 11.1804 12.1427 11.2178C12.0687 11.2551 11.9877 11.2765 11.9049 11.2807C11.8222 11.2848 11.7394 11.2716 11.6621 11.2418C11.5847 11.212 11.5145 11.1664 11.4558 11.1079L8.38375 8.03581L4.04225 14.0054C3.94728 14.1261 3.80919 14.2054 3.65701 14.2265C3.50482 14.2476 3.35039 14.2088 3.22617 14.1184C3.10194 14.028 3.01759 13.893 2.99085 13.7417C2.96411 13.5904 2.99705 13.4346 3.08275 13.3071L7.83275 6.77587C7.88317 6.70642 7.94804 6.64873 8.0229 6.60676C8.09777 6.56479 8.18084 6.53956 8.26639 6.53278C8.35194 6.52601 8.43795 6.53787 8.51848 6.56753C8.59902 6.5972 8.67216 6.64397 8.73287 6.70463L11.8311 9.804L15.9659 4.75H12.4688C12.3113 4.75 12.1603 4.68744 12.0489 4.57609C11.9376 4.46475 11.875 4.31372 11.875 4.15625Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("statisticsData") }}</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'scheduled' }" :title="$t('scheduled')">
            <div class="icon">
              <svg
                  width="24"
                  height="24"
                  viewbox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M9,10V12H7V10H9M13,10V12H11V10H13M17,10V12H15V10H17M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5A2,2 0 0,1 5,3H6V1H8V3H16V1H18V3H19M19,19V8H5V19H19M9,14V16H7V14H9M13,14V16H11V14H13M17,14V16H15V14H17Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("scheduled") }}</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'recurring-contract-update' }" :title="$t('recurringContractUpdate')">
            <div class="icon">
              <svg width="19"
                   height="19"
                   viewbox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.66667 16.6667C1.20833 16.6667 0.815833 16.5036 0.489167 16.1775C0.163055 15.8508 0 15.4583 0 15V3.33333C0 2.875 0.163055 2.48278 0.489167 2.15667C0.815833 1.83 1.20833 1.66667 1.66667 1.66667H2.5V0H4.16667V1.66667H10.8333V0H12.5V1.66667H13.3333C13.7917 1.66667 14.1842 1.83 14.5108 2.15667C14.8369 2.48278 15 2.875 15 3.33333V8.33333H13.3333V6.66667H1.66667V15H7.5V16.6667H1.66667ZM15.9375 12.5L14.1667 10.7292L14.7708 10.125C14.9236 9.97222 15.1181 9.89583 15.3542 9.89583C15.5903 9.89583 15.7847 9.97222 15.9375 10.125L16.5417 10.7292C16.6944 10.8819 16.7708 11.0764 16.7708 11.3125C16.7708 11.5486 16.6944 11.7431 16.5417 11.8958L15.9375 12.5ZM9.16667 17.5V15.7292L13.5833 11.3125L15.3542 13.0833L10.9375 17.5H9.16667ZM1.66667 5H13.3333V3.33333H1.66667V5ZM1.66667 5V3.33333V5Z"
                    fill="#C0BEFF"/>
              </svg>

            </div>
            <span>{{ $t("recurringContractUpdate") }}</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'billing' }" :title="$t('billing')">
            <div class="icon">
              <svg
                  width="19"
                  height="19"
                  viewbox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M0 0V17.6429H11.6923V16.2857H1.46154V1.35714H8.76923V5.42857H13.1538V6.78571H14.6154V4.47857L14.3962 4.275L10.0115 0.203571L9.79231 0H0ZM10.2308 2.30714L12.1308 4.07143H10.2308V2.30714ZM2.92308 6.78571V8.14286H11.6923V6.78571H2.92308ZM15.3462 8.14286V9.5C14.1038 9.70357 13.1538 10.6536 13.1538 11.875C13.1538 13.2321 14.25 14.25 15.7115 14.25H16.4423C17.0269 14.25 17.5385 14.725 17.5385 15.2679C17.5385 15.8107 17.0269 16.2857 16.4423 16.2857H13.8846V17.6429H15.3462V19H16.8077V17.6429C18.05 17.4393 19 16.4893 19 15.2679C19 13.9107 17.9038 12.8929 16.4423 12.8929H15.7115C15.1269 12.8929 14.6154 12.4179 14.6154 11.875C14.6154 11.3321 15.1269 10.8571 15.7115 10.8571H18.2692V9.5H16.8077V8.14286H15.3462ZM2.92308 10.1786V11.5357H8.03846V10.1786H2.92308ZM9.5 10.1786V11.5357H11.6923V10.1786H9.5ZM2.92308 12.8929V14.25H8.03846V12.8929H2.92308ZM9.5 12.8929V14.25H11.6923V12.8929H9.5Z"
                    fill="#C0BEFF"
                ></path>
              </svg>
            </div>
            <span>{{ $t("billing") }}</span></router-link
          >
        </li>

        <li>
          <router-link :to="{ name: 'faq' }" :title="$t('faq')">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20">
                <path
                    d="M10.021 15.146q.437 0 .729-.302t.292-.719q0-.417-.292-.719t-.708-.302q-.438 0-.73.292-.291.292-.291.729 0 .417.291.719.292.302.709.302Zm-.833-3.271h1.666q0-.792.125-1.135.125-.344.667-.907.75-.666 1.031-1.198.281-.531.281-1.135 0-1.188-.812-1.927-.813-.74-2.063-.74-1.104 0-1.927.584Q7.333 6 7.021 7l1.479.604q.167-.583.552-.916.386-.334.969-.334.604 0 .989.344.386.344.386.864 0 .48-.344.844-.344.365-.74.74-.75.687-.937 1.146-.187.458-.187 1.583ZM10 18.25q-1.688 0-3.198-.646t-2.635-1.771q-1.125-1.125-1.771-2.625-.646-1.5-.646-3.208 0-1.729.646-3.229t1.771-2.625q1.125-1.125 2.635-1.761Q8.312 1.75 10 1.75q1.729 0 3.229.635 1.5.636 2.625 1.761t1.761 2.625q.635 1.5.635 3.229 0 1.708-.635 3.208-.636 1.5-1.761 2.625t-2.625 1.771q-1.5.646-3.229.646Zm0-1.625q2.771 0 4.698-1.927 1.927-1.927 1.927-4.698 0-2.771-1.927-4.698Q12.771 3.375 10 3.375q-2.771 0-4.698 1.927Q3.375 7.229 3.375 10q0 2.771 1.927 4.698Q7.229 16.625 10 16.625ZM10 10Z"
                    fill="#C0BEFF"
                />
              </svg>
            </div>
            <span>{{ $t("faq") }}</span></router-link
          >
        </li>

        <li>
          <router-link :to="{ name: 'support' }" :title="$t('support')">
            <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20">
                <path
                    d="M9.208
                18.167v-1.875h6.667V9.979q0-1.167-.49-2.219-.489-1.052-1.291-1.843-.802-.792-1.865-1.261-1.062-.468-2.229-.468-1.146
                0-2.219.468-1.073.469-1.875 1.261-.802.791-1.291 1.843-.49
                1.052-.49
                2.219v5.104H1.417v-4.687h.833l.042-.917q.104-1.5.812-2.823.708-1.323
                1.781-2.323t2.396-1.562Q8.604 2.208 10 2.208t2.729.573q1.333.573
                2.406 1.563 1.073.989 1.771 2.312t.802
                2.802l.042.938h.833v4.687h-.833v3.084Zm-1.541-5.709q-.417
                0-.74-.323t-.323-.718q0-.417.323-.74t.74-.323q.395 0
                .718.323.323.323.323.74 0 .395-.323.718-.323.323-.718.323Zm4.666
                0q-.395 0-.718-.323-.323-.323-.323-.718
                0-.417.323-.74t.718-.323q.417 0 .74.323t.323.74q0
                .395-.323.718-.323.323-.74.323Zm-7.187-1.52q-.084-1.126.208-2.167.292-1.042.927-1.833.636-.792
                1.584-1.261.947-.469 2.177-.469 1.875 0 3.229 1.282 1.354 1.281
                1.667 3.198-1.896.124-3.365-.688-1.469-.812-2.344-2.167-.458
                1.459-1.51 2.521-1.052 1.063-2.573 1.584Z"
                    fill="#C0BEFF"
                />
              </svg>
            </div>
            <span>{{ $t("support") }}</span></router-link
          >
        </li>
      </ul>
      <ul class="list-unstyled">
        <li>
          <router-link
              :to="{ name: 'configurations' }"
              :title="$t('configuration')"
          >
            <div class="icon">
              <svg
                  class="settings"
                  width="22"
                  height="22"
                  viewbox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M16.7659 6.4885C16.5736 6.20016 16.303 5.97265 15.986 5.83269C15.6689 5.69272 15.3185 5.64611 14.9758 5.69831C14.4259 5.77664 13.8656 5.66966 13.3832 5.39424C12.9008 5.11881 12.5238 4.69062 12.3118 4.17721C12.0402 3.52022 11.4322 3.06991 10.7219 3.03424C10.4614 3.02114 10.2004 3.02114 9.9399 3.03424C9.2249 3.07206 8.61431 3.52795 8.34576 4.19139C8.13798 4.70538 7.76525 5.13571 7.28618 5.41472C6.80711 5.69373 6.24889 5.80558 5.69931 5.73268C4.9899 5.63858 4.29209 5.94452 3.90666 6.54909C3.75346 6.78877 3.61374 7.03679 3.48814 7.29202C3.18306 7.91334 3.30123 8.62834 3.72748 9.17362C4.06987 9.61084 4.25688 10.1496 4.25898 10.705C4.26108 11.2603 4.07815 11.8005 3.73908 12.2403C3.31541 12.7907 3.20197 13.5074 3.51178 14.1309C3.58053 14.2684 3.654 14.4046 3.7322 14.5396C3.79952 14.6541 3.86942 14.7667 3.94189 14.8773C4.13424 15.1656 4.40482 15.3931 4.72188 15.533C5.03894 15.673 5.38934 15.7196 5.73197 15.6675C6.28191 15.589 6.84233 15.6959 7.32475 15.9714C7.80717 16.2468 8.1841 16.6751 8.39603 17.1886C8.6676 17.8456 9.27603 18.2959 9.98588 18.3311C10.2464 18.3447 10.5074 18.3447 10.7679 18.3311C11.4829 18.2937 12.0935 17.8378 12.362 17.1744C12.5697 16.6604 12.9423 16.23 13.4213 15.951C13.9003 15.672 14.4585 15.5602 15.0081 15.6331C15.7179 15.7272 16.4157 15.4213 16.8012 14.8167C16.9542 14.5769 17.0938 14.3287 17.2192 14.0733C17.5247 13.4524 17.4066 12.7374 16.9799 12.1922C16.6377 11.7548 16.4508 11.2159 16.4488 10.6605C16.4468 10.1052 16.6297 9.56494 16.9687 9.12506C17.3924 8.57506 17.5058 7.85834 17.1956 7.23659C17.1274 7.09909 17.0539 6.96288 16.9752 6.82795C16.9081 6.71251 16.8384 6.59936 16.7659 6.4885Z"
                    stroke="#C0BEFF"
                    stroke-width="1.32624"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></path>
                <path
                    d="M10.3544 12.7459C11.4939 12.7459 12.4177 11.8221 12.4177 10.6825C12.4177 9.54294 11.4939 8.61914 10.3544 8.61914C9.21481 8.61914 8.29102 9.54294 8.29102 10.6825C8.29102 11.8221 9.21481 12.7459 10.3544 12.7459Z"
                    stroke="#C0BEFF"
                    stroke-width="1.32624"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                ></path>
              </svg>
            </div>
            <span
            >{{ $t("settings") }}/<br/>{{ $t("configuration") }}</span
            ></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'users' }" :title="$t('users')">
            <div class="icon">
              <svg
                  width="21"
                  height="21"
                  viewbox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M10.505 10.575C11.7853 10.575 13.0132 10.0667 13.9185 9.1618C14.8239 8.25694 15.3325 7.02968 15.3325 5.75C15.3325 4.47032 14.8239 3.24306 13.9185 2.3382C13.0132 1.43334 11.7853 0.925 10.505 0.925C9.22468 0.925 7.99679 1.43334 7.09146 2.3382C6.18612 3.24306 5.6775 4.47032 5.6775 5.75C5.6775 7.02968 6.18612 8.25694 7.09146 9.1618C7.99679 10.0667 9.22468 10.575 10.505 10.575ZM13.5983 5.75C13.5983 6.56995 13.2724 7.35632 12.6923 7.93612C12.1122 8.51593 11.3254 8.84167 10.505 8.84167C9.68458 8.84167 8.89778 8.51593 8.31767 7.93612C7.73756 7.35632 7.41167 6.56995 7.41167 5.75C7.41167 4.93005 7.73756 4.14368 8.31767 3.56388C8.89778 2.98407 9.68458 2.65833 10.505 2.65833C11.3254 2.65833 12.1122 2.98407 12.6923 3.56388C13.2724 4.14368 13.5983 4.93005 13.5983 5.75ZM18.4258 20L18.4259 20.075L18.4261 20.075H18.4264L18.4276 20.075L18.4316 20.0749L18.4461 20.0746C18.4586 20.0742 18.4766 20.0733 18.4992 20.0717C18.5446 20.0685 18.6088 20.062 18.6857 20.0492C18.8391 20.0237 19.0448 19.9724 19.2514 19.8692C19.4584 19.7658 19.6676 19.6095 19.8249 19.3736C19.9825 19.1373 20.085 18.8256 20.085 18.4167C20.085 17.6057 19.6815 16.0031 18.2808 14.6032C16.878 13.2011 14.4812 12.0083 10.505 12.0083C6.52878 12.0083 4.13202 13.2011 2.72917 14.6032C1.32851 16.0031 0.925 17.6057 0.925 18.4167C0.925 18.8256 1.02751 19.1373 1.18513 19.3736C1.34244 19.6095 1.55164 19.7658 1.75856 19.8692C1.96518 19.9724 2.17089 20.0237 2.32432 20.0492C2.40121 20.062 2.46545 20.0685 2.51076 20.0717C2.53342 20.0733 2.55139 20.0742 2.56388 20.0746L2.57841 20.0749L2.58242 20.075L2.58358 20.075H2.58395L2.58408 20.075L2.58417 20V20.075H18.4258V20ZM17.0548 15.8287C18.0505 16.8239 18.318 17.9017 18.3479 18.3353H2.66237C2.69343 17.9012 2.95974 16.8237 3.95521 15.8287C4.97141 14.8131 6.89311 13.7417 10.505 13.7417C14.1153 13.7417 16.0386 14.8131 17.0548 15.8287Z"
                    fill="#C0BEFF"
                    stroke="#C0BEFF"
                    stroke-width="0.15"
                ></path>
              </svg>
            </div>
            <span>{{ $t("users") }}</span></router-link
          >
        </li>
        <li>
          <router-link :to="{ name: 'video-guides' }" :title="$t('videoGuides')">
            <div class="icon">
              <img src="./../../../assets/images/icon-utility/videoGuide.png" alt="video guides"/>
            </div>
            <span>{{ $t("videoGuides") }}</span></router-link
          >
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {onMounted, ref, watchEffect} from "vue";

export default {
  name: "sidebarComponent",
  setup() {
    const openSidebar = ref(false);

    const toggleSidebar = () => {
      const sidebar = document.querySelector(".sidebar");
      const closeBtn = document.querySelector("#btn");
      // const _ = document.querySelector('.responsive-width')
      if (closeBtn) {
        closeBtn.addEventListener("click", () => {
          sidebar.classList.toggle("close");
          sidebar.classList.toggle("open");
          openSidebar.value = !openSidebar.value;
        });
      }
    };

    watchEffect(() => {
      if (openSidebar.value) {
        document.querySelector(".sidebar").classList.add("open");
      }
      // else {
      //     document.querySelector('.sidebar').classList.remove('open')
      // }
    });
    onMounted(toggleSidebar);

    return {};
  },
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  background-color: #f6f8fc;
  color: #333269;
}

.router-link-exact-active path {
  fill: #333269;
}

.open > nav {
  height: 80vh;
  overflow-y: scroll;
  overflow-x: hidden;
  margin-bottom: 100px;
  scrollbar-width: none;
}

.open > nav::-webkit-scrollbar {
  width: 0px;
  display: none;
}
</style>
